import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '../../../components/special/LanguageProvider';
import { apiPostCall } from '../../../components/special/apiCall';
import InputText  from 'components/input/InputText';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const SettingRegex = ({ definition }) => {   
    // const [settingValue, setSettingValue] = useState(JSON.parse(definition.value));
    // const { t } = useLocale();

    // const onUpdateValue = (value) => {
    //     let jsonValue = JSON.stringify(value);
    //     if (jsonValue != definition.value){
    //         apiPostCall(BASE_URL + '/admin/setting/save', {...definition, value : jsonValue}).then(res => {      
    //             setSettingValue(value);
    //         });        
    //     }
    // }
    
    // console.log("setting", settingValue);

    return (      
        <div className="form">
            {/* <InputText value={settingValue} onChange={(value) => onUpdateValue(value)} label={t(definition.name)} /> */}
        </div>                  
      );
};


export default SettingRegex;
